import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite';
import { Collapse, Grid } from '@material-ui/core';
import { Element } from 'react-scroll';
import parser from 'react-html-parser'
import './index.scss';
import { useMedia } from '@commons/media';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { faPlus, faMinus, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import RootStore from "@stores"
import { base64Decode } from '@commons/util';

interface QNAProps {}

interface QnaItem {
    answer: string,
    qnaOrder: string,
    question: string,
    refno?: string
    status?: string,
    open?: boolean
}

const QNA:React.FC<QNAProps> = observer((props)=> {
    const {mbsMatches, mediaClass} = useMedia()
    const [qnaOpen, setQnaOpen] = useState(true)
    const {i18n} = useTranslation();
    const language = i18n.language
    const {
        portalContent
    } = RootStore.PortalStore;


    const [qnaList, setQnaList] = useState<QnaItem[]>([]);

    useEffect(() => {
        let mgmQnas = i18n.getResource(language, "portal", "mgmQnas")
        if (mgmQnas) {
            // sort by qna order
            let orderingQnas = mgmQnas.map((item:any) => item).sort((a:any, b:any) => Number(a.qnaOrder) - Number(b.qnaOrder));
            setQnaList(orderingQnas)
        }
    }, [portalContent, language, i18n])


    const handleExpand = () => {
        setQnaOpen(!qnaOpen)
    }

    const changeQnaItemOpen = (i: number, status: boolean) => {
        setQnaList((prevItems) =>
            prevItems.map((item , index) =>
                index === i ? {...item, open: !status} : item
            ) 
        )
    }
    return (
        <Element name="qna">
            <Grid container justifyContent='center'>
                <Grid container className='main-qna-maxwidth qna-list'>
                    <Grid container>
                        <Grid container className={`${mediaClass('qna-header-title')}`} justifyContent='center' alignItems='center' onClick={handleExpand}>
                            <h2>{i18n.t('portal:QNATitle')}</h2>
                            {
                                qnaOpen ? 
                                <FontAwesomeIcon icon={faChevronUp} className={`${mediaClass('qna-icon')}`}  />
                                : <FontAwesomeIcon icon={faChevronDown} className={`${mediaClass('qna-icon')}`} />
                            }
                        </Grid>
                    </Grid>
                    {
                        portalContent && qnaOpen &&
                            <Grid container>
                                    {
                                        qnaList.length && qnaList.map((qna, i) => (
                                            <Grid container key={i} className='qna-item' style={{ rowGap: '10px' }}>
                                                <Grid container justifyContent='space-between' className={`${mediaClass('qna-item-title')}`}>
                                                    <Grid item xs={11} container>
                                                        <div style={{flexBasis: '30px'}}>{`${i+1}.`}</div>
                                                        <div style={{width: "85%"}} onClick={() => changeQnaItemOpen(i, !!qna.open)}>{qna.question}</div>
                                                    </Grid>
                                                    <Grid item xs={1}>
                                                        {
                                                            qna.open ? 
                                                            <FontAwesomeIcon icon={faMinus} size={mbsMatches?'sm': 'lg'} onClick={() => changeQnaItemOpen(i, !!qna.open)}></FontAwesomeIcon>
                                                            : <FontAwesomeIcon icon={faPlus} size={mbsMatches?'sm': 'lg'} onClick={() => changeQnaItemOpen(i, !!qna.open)}></FontAwesomeIcon>
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Collapse in={qna.open} style={{width: '100%'}}>
                                                    <Grid container justifyContent='space-between' className={`qna-item-desc ${qna.open ? 'qna-item-desc-open': ''}`}>
                                                        <Grid item xs={11}>
                                                            {
                                                                qna.open ? <div style={{marginLeft: "40px"}}>{parser(base64Decode(qna.answer))}</div> : <></>
                                                            }
                                                        </Grid>
                                                        <Grid item xs={1}></Grid>
                                                    </Grid>
                                                </Collapse>
                                            </Grid>
                                        ))
                                    }
                            </Grid> 
                    }
                </Grid>
            </Grid>
        </Element>
    )
})

export default QNA;